import React from 'react';
import ButtonAppBar from './AppBar';
import "./css/landing.css";

class Landing extends React.Component {
   
    render (){
        let styles_flex = {
            display: "flex",
        }
    return (
        <ButtonAppBar />
    );
    }
  }

  export default Landing;


// WEBPACK FOOTER //
// ./src/LandingPage/Landing.js